(() => {
  'use strict';

  if (window.__infarmasiParacetamolCalculatorLoaded) return;
  window.__infarmasiParacetamolCalculatorLoaded = true;

  const ROOT_SELECTOR = '.ifc-wrap';

  const optionLabels = {
    '250': 'Sirap 250 mg/5 mL',
    '120': 'Sirap 120 mg/5 mL',
    supp125: 'Suppository 125 mg — semakan julat berat',
    supp250: 'Suppository 250 mg — semakan julat berat',
  };

  const prepare = (root) => {
    if (!root) return;

    const subtitle = root.querySelector('.ifc-subtitle');
    const warning = root.querySelector('.ifc-warn');
    const formSelect = root.querySelector('#ifc-form');

    if (subtitle) {
      subtitle.textContent = 'Sirap dikira ikut berat badan untuk kanak-kanak berumur lebih 3 bulan. Untuk suppository, alat ini hanya menyemak julat berat pada label rujukan dan bukan kalkulator dos rektal.';
    }

    if (warning) {
      warning.textContent = 'Bayi bawah 3 bulan: jangan gunakan kalkulator ini. Jika suhu 38°C atau lebih, dapatkan penilaian perubatan segera.';
    }

    if (formSelect) {
      Array.from(formSelect.options).forEach((option) => {
        if (optionLabels[option.value]) option.textContent = optionLabels[option.value];
      });
    }
  };

  const addText = (result, className, text) => {
    const node = document.createElement(className === 'ifc-dose' ? 'div' : 'p');
    node.className = className;
    node.textContent = text;
    result.appendChild(node);
  };

  const showResult = (result, title, details, isError = false) => {
    result.replaceChildren();
    result.classList.add('show');
    result.classList.toggle('error', isError);
    addText(result, 'ifc-dose', title);
    details.forEach((detail) => addText(result, 'ifc-detail', detail));
  };

  const clearResult = (root) => {
    const result = root ? root.querySelector('#ifc-result') : null;
    if (!result) return;

    result.replaceChildren();
    result.classList.remove('show', 'error');
  };

  const calculate = (root) => {
    const weightInput = root.querySelector('#ifc-weight');
    const formSelect = root.querySelector('#ifc-form');
    const result = root.querySelector('#ifc-result');

    if (!weightInput || !formSelect || !result) return;

    const weight = Number.parseFloat(weightInput.value);

    if (!Number.isFinite(weight) || weight < 3 || weight > 50) {
      showResult(result, 'Semak berat badan', [
        'Masukkan berat antara 3 kg hingga 50 kg. Jika bayi berumur bawah 3 bulan, dapatkan nasihat profesional sebelum menggunakan paracetamol.',
      ], true);
      return;
    }

    const selected = formSelect.value;

    if (selected === '250' || selected === '120') {
      const strength = Number(selected);
      const concentration = strength / 5;
      const doseMg = weight * 15;
      const volumeMl = doseMg / concentration;
      const roundedMl = Math.round(volumeMl * 10) / 10;
      const roundedDose = Math.round(doseMg * 10) / 10;

      showResult(result, `${roundedMl.toFixed(1)} mL`, [
        `Bersamaan ${roundedDose} mg bagi satu dos untuk berat ${weight} kg (15 mg/kg).`,
        `Kepekatan dipilih: ${strength} mg/5 mL.`,
        'Untuk penggunaan di rumah, jangan melebihi 4 dos keseluruhan atau 60 mg/kg dalam 24 jam. Ikut label produk jika hadnya lebih ketat.',
        'Gunakan picagari oral untuk sukatan yang lebih tepat. Sirap dan suppository mengandungi paracetamol dan perlu dikira bersama.',
      ]);
      return;
    }

    const suppository = selected === 'supp125'
      ? { strength: 125, min: 10, max: 20, name: 'GACET-125' }
      : selected === 'supp250'
        ? { strength: 250, min: 20, max: 40, name: 'GACET-250' }
        : null;

    if (!suppository) {
      showResult(result, 'Pilihan tidak dikenali', ['Sila pilih jenis paracetamol semula.'], true);
      return;
    }

    const inBand = weight >= suppository.min && weight <= suppository.max;
    const mgPerKg = suppository.strength / weight;
    const roundedMgPerKg = Math.round(mgPerKg * 10) / 10;
    const band = `${suppository.min}–${suppository.max} kg`;

    if (!inBand) {
      showResult(result, 'Di luar julat berat rujukan', [
        `Berat ${weight} kg berada di luar julat berat label rujukan ${suppository.name} (${band}).`,
        `Alat ini tidak akan mencadangkan suppository ${suppository.strength} mg untuk berat ini. Semak label produk sebenar atau rujuk doktor/ahli farmasi.`,
        'Produk suppository paracetamol lain mungkin mempunyai arahan yang berbeza.',
      ], true);
      return;
    }

    showResult(result, 'Dalam julat berat rujukan label', [
      `RiMUP ${suppository.name} menyenaraikan julat berat ${band}. Berat ${weight} kg berada dalam julat tersebut.`,
      `${suppository.strength} mg ÷ ${weight} kg = ${roundedMgPerKg.toFixed(1)} mg/kg bagi 1 suppository whole. Nilai ini hanya rujukan matematik, bukan cadangan kuantiti dos.`,
      'Jangan pecahkan suppository. Kuantiti sebenar dan selang dos mesti ikut label tepat produk atau arahan doktor/ahli farmasi.',
      'Produk suppository paracetamol lain mungkin mempunyai arahan yang berbeza daripada GACET.',
    ]);
  };

  const prepareAll = () => {
    document.querySelectorAll(ROOT_SELECTOR).forEach(prepare);
  };

  document.addEventListener('click', (event) => {
    const target = event.target instanceof Element ? event.target : null;
    const button = target ? target.closest('.ifc-btn') : null;
    if (!button) return;

    const root = button.closest(ROOT_SELECTOR);
    if (!root) return;

    prepare(root);
    calculate(root);
  });

  document.addEventListener('input', (event) => {
    const target = event.target instanceof Element ? event.target : null;
    if (!target || target.id !== 'ifc-weight') return;

    const root = target.closest(ROOT_SELECTOR);
    if (!root) return;

    clearResult(root);
  });

  document.addEventListener('change', (event) => {
    const target = event.target instanceof Element ? event.target : null;
    if (!target || target.id !== 'ifc-form') return;

    const root = target.closest(ROOT_SELECTOR);
    if (!root) return;

    clearResult(root);
  });

  document.addEventListener('keydown', (event) => {
    const target = event.target instanceof Element ? event.target : null;
    if (event.key !== 'Enter' || !target || target.id !== 'ifc-weight') return;

    const root = target.closest(ROOT_SELECTOR);
    if (!root) return;

    event.preventDefault();
    prepare(root);
    calculate(root);
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', prepareAll, { once: true });
  } else {
    prepareAll();
  }

  document.addEventListener('shopify:section:load', prepareAll);
})();
